export const GET_ARTICLE_FAIL = "GET_ARTICLE_FAIL";
export const GET_ARTICLES = "GET_ARTICLES";
export const ARTICLE_REQUEST = "ARTICLE_REQUEST";
